import styled from 'styled-components'
import { VARIABLES } from '../../themes'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const SourcingCompareEventBuyerStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  .form-group-attached-file {
    min-width: 0;
    flex-wrap: wrap;
    display: flex;
    column-gap: 10px;
    row-gap: 5px;
    /* position: relative; */
    align-items: center;
    max-width: 100%;
  }

  .loading {
    position: absolute;
    bottom: 15px;
    right: 60px;
    display: flex;
    justify-content: flex-end;
  }

  .attachment-approval {
    .input-upload-control {
      width: auto;
      min-width: auto;
      flex: auto;
      max-width: max-content;
    }
  }

  .form-group > label {
    flex: 0 0 165px;
  }

  .form-group {
    &.date-period {
      .date-picker-wrapper {
        width: 100%;
        max-width: 500px;
        min-width: 250px;
      }
    }

    &.status {
      .form-group-inner-wrapper {
        position: relative;
      }

      .status-icon-help {
        width: 18px;
        position: absolute;
        left: 125px;
        z-index: 2;
      }
    }

    .form-group-inner-wrapper {
      /* flex-wrap: wrap; */ //Bug Wrapper ellipsis : Noolek
      /* flex-direction: column;
      align-items: start; */
    }
  }

  .form-group .target-saving .input-control {
    max-width: 125px;
    min-width: 80px;
    margin-right: 10px;

    .input {
      text-align: center;
    }
  }

  .main-content .content-body .form-actions {
    margin-top: 50px;
    /* margin-bottom: 50px; */

    .button-group {
      &:last-child {
        justify-content: flex-end;
      }
    }

    .button {
      width: 145px;
    }

    .re-submit-button {
      width: 200px;
    }
  }

  .text {
    color: ${VARIABLES.COLORS.BLUE_1};
  }

  .compare-event-table-wrapper {
    overflow: auto;

    /* width */
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${VARIABLES.COLORS.GRAY_2};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${VARIABLES.COLORS.BLUE_4};
      border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${VARIABLES.COLORS.BLUE_1};
    }
  }

  .compare-event {
    max-height: 180px;

    .tbody {
      width: 100%;
    }

    .table-row {
      .table-column {
        height: auto;
      }

      .check-box {
        max-width: 55px;
        flex: 0 0 5%;
        min-width: 60px;
      }

      .tax-id {
        flex: 0 0 15%;
        min-width: 150px;
      }

      .no {
        flex: 0 0 4%;
        min-width: 60px;
      }

      .supplier-name {
        flex: 0 0 25%;
        min-width: 170px;
      }

      .contact-name {
        flex: 0 0 20%;
        min-width: 170px;
      }

      .phone {
        flex: 0 0 15%;
        min-width: 120px;
      }

      .email {
        flex: 0 0 18%;
        min-width: 170px;
      }

      .response-date {
        flex: 0 0 18%;
        justify-content: center;
        text-align: center;
        min-width: 150px;
      }

      .term-status {
        flex: 0 0 15%;
        justify-content: center;
        text-align: center;
        min-width: 150px;
      }

      .status {
        flex: 0 0 15%;
        min-width: 150px;
        .response-status {
          justify-content: center;
        }
        .rejected {
          justify-content: center;
          color: ${VARIABLES.COLORS.RED_3};
          .link {
            width: fit-content;
            margin-left: 6px;
          }
        }
      }
    }
  }

  .compare-list-wrapper {
    margin-top: 24px;

    .react-tabs__tab-list {
      &:before {
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom-right-radius: 0;
      }
    }
  }

  .text-right {
    justify-content: end;
    text-align: right;
  }

  .cut-word {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .compare-list {
    display: table;
    width: 100%;
    table-layout: fixed;
    position: relative;
    text-align: center;

    tr {
      width: 100%;
      display: flex;
    }

    th {
      font-weight: 600;
      color: ${VARIABLES.COLORS.BLUE_1};
      height: 45px;
      background-color: ${VARIABLES.COLORS.GRAY_6};
      line-height: 2.7;

      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }

    .button-save {
      position: absolute;
      width: auto;
      left: 28%;
    }

    &-table {
      overflow: auto;
      flex-wrap: wrap;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    &.total {
      .supplier-item {
        td {
          background-color: transparent !important;
        }
      }
    }

    td {
      vertical-align: top;
    }

    .table-column {
      background-color: transparent;
    }

    .no {
      flex: 0 0 4%;
      width: 4%;
      text-align: center;
    }

    .item {
      flex: 0 0 24%;
      width: 24%;

      .button {
        width: auto;
        max-width: 150px;
        /* max-width: 55%; */
        margin-bottom: 10px;

        &[class*='theme-'] {
          width: fit-content;
          min-width: 170px;
          max-width: max-content;
          padding: 0 10px;
        }
      }

      /* .button[class*='theme-'] {
        width: fit-content;
        min-width: 170px;
        max-width: auto;
        padding: 0 10px;
      } */
    }

    .supplier-name {
      flex: 0 0 24%;
      width: 24%;
      /* justify-content: center; */

      &-list {
        width: 72%;
      }
    }

    .supplier-name-lock {
      flex: 0 0 24%;
      width: 24%;
      display: flex;
      align-items: center;
      justify-content: start;

      &-list {
        width: 72%;
      }
    }

    .displayAlign {
      display: flex;
      align-items: center;
    }

    .supplier-item {
      width: 100%;

      td {
        /* width: 33.3%; */
        padding: 15px 10px 10px;

        &:nth-child(odd) {
          background-color: ${VARIABLES.COLORS.GRAY_4};
        }

        &.no {
          background-color: white;
        }

        .col-6 {
          max-width: 50%;

          &:last-child {
            justify-content: flex-end;
          }
        }

        .bold {
          font-weight: 600;
        }
      }

      &-row:nth-child(odd) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        td {
          &:nth-child(odd) {
            background-color: ${VARIABLES.COLORS.GRAY_16};
          }
          &.no {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }
        }
      }

      &-check:nth-child(odd) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        td {
          &:nth-child(odd) {
            background-color: ${VARIABLES.COLORS.GRAY_16};
          }
          &.no {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }
        }
      }
      &-save:nth-child(2n) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
      }
    }

    &.split-row-color {
      .no {
        padding-top: 15px;
      }

      .item {
        padding-top: 15px;
      }

      tr {
        &:nth-child(even) {
          .no,
          .item {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }

          .supplier-item {
            td:nth-child(odd) {
              background-color: ${VARIABLES.COLORS.GRAY_16};
            }
            td:nth-child(2) {
              background-color: ${VARIABLES.COLORS.GRAY_7};
            }
          }
        }
      }

      .total-item {
        padding: 10px;
        justify-content: flex-end;
      }

      td {
        &:first-child {
          .total-item {
            justify-content: center;
          }
        }
      }
    }

    .attached-file-list {
      a.file-link {
        padding-top: 3px;
        padding-bottom: 3px;
        cursor: pointer;
        max-width: unset;
        width: 100%;
      }
    }
  }

  .custom-compare-list {
    display: table;
    width: 100%;
    table-layout: fixed;
    position: relative;
    text-align: center;

    .text-center {
      text-align: center;
    }

    .truncate {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .line-clamp-3 {
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
    }

    .w-max {
      max-width: 100%;
    }

    thead {
      display: flex;
      width: 100%;
      background-color: ${VARIABLES.COLORS.GRAY_6};
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      tr {
        display: flex;
        align-items: center;
        width: 100%;
      }

      th {
        display: flex;
        align-items: center;
        width: 100%;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }

    tr {
      width: 100%;
      display: flex;
    }

    th {
      font-weight: 600;
      color: ${VARIABLES.COLORS.BLUE_1};
      height: 45px;
      background-color: ${VARIABLES.COLORS.GRAY_6};

      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }

      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }

    .checkbox {
      .fake-input {
        display: flex;
        align-items: center;
        width: 100%;
      }

      .fake-label {
        display: flex;
        align-items: center;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        display: inline-block;
        cursor: pointer;
      }

      .fake-checkbox {
        margin-top: 0;
      }
    }

    .button-save {
      position: absolute;
      width: auto;
      left: 28%;
    }

    &-table {
      overflow: auto;
      flex-wrap: wrap;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    &.total {
      .supplier-item {
        td {
          background-color: transparent !important;
        }
      }
    }

    td {
      vertical-align: top;
    }

    .table-column {
      background-color: transparent;
    }

    .no {
      flex: 0 0 4%;
      width: 4%;
      text-align: center;
    }

    .item {
      flex: 0 0 24%;
      width: 24%;

      .button {
        width: auto;
        max-width: 150px;
        /* max-width: 55%; */
        margin-bottom: 10px;

        &[class*='theme-'] {
          width: fit-content;
          min-width: 170px;
          max-width: max-content;
          padding: 0 10px;
        }
      }

      .action-button-centered {
        justify-content: center;
        margin-top: auto;
      }
    }

    .supplier-name {
      flex: 0 0 24%;
      width: 24%;
      min-width: 320px;
      position: relative;

      .supplier-item {
        display: flex;
        flex-direction: column;
      }

      .form-row {
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .action-button-supplier {
        margin-top: auto;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .supplier-item {
      width: 100%;

      td {
        /* width: 33.3%; */
        padding: 15px 10px 10px;

        &:nth-child(odd) {
          background-color: ${VARIABLES.COLORS.GRAY_4};
        }

        &.no {
          background-color: white;
        }

        .col-6 {
          max-width: 50%;

          &:last-child {
            justify-content: flex-end;
          }
        }

        .bold {
          font-weight: 600;
        }
      }

      &-row:nth-child(odd) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        td {
          &:nth-child(odd) {
            background-color: ${VARIABLES.COLORS.GRAY_16};
          }
          &.no {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }
        }
      }

      &-check:nth-child(odd) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
        td {
          &:nth-child(odd) {
            background-color: ${VARIABLES.COLORS.GRAY_16};
          }
          &.no {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }
        }
      }
      &-save:nth-child(2n) {
        background-color: ${VARIABLES.COLORS.GRAY_7};
      }
    }

    &.split-row-color {
      .no {
        padding-top: 15px;
      }

      .item {
        padding-top: 15px;
      }

      tr {
        &:nth-child(even) {
          .no,
          .item {
            background-color: ${VARIABLES.COLORS.GRAY_7};
          }

          .supplier-item {
            td:nth-child(odd) {
              background-color: ${VARIABLES.COLORS.GRAY_16};
            }
            td:nth-child(2) {
              background-color: ${VARIABLES.COLORS.GRAY_7};
            }
          }
        }
      }

      .total-item {
        padding: 10px;
        justify-content: flex-end;
      }

      td {
        &:first-child {
          .total-item {
            justify-content: center;
          }
        }
      }
    }

    .attached-file-list {
      a.file-link {
        padding-top: 3px;
        padding-bottom: 3px;
        cursor: pointer;
        max-width: unset;
        width: 100%;
      }
    }

    .action-button-supplier {
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: end;
      margin-bottom: 10px;

      .button {
        width: 100%;
        min-width: 170px;
        max-width: 200px;
        padding: 0 10px;
      }
    }
  }

  .add-supplier {
    .table-wrapper {
      overflow: auto;
      flex-wrap: wrap;
      max-height: 270px;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    .page-button {
      justify-content: flex-end;
    }

    .company-name {
      flex: 0 0 19%;
      min-width: auto;
    }

    .email {
      flex: 0 0 15%;
    }

    .actions {
      .section {
        justify-content: center;
      }

      .button {
        max-width: max-content;
        padding: 0 10px;
      }
    }

    .form-group {
      .select-control {
        min-width: auto;
        max-width: 105px;
        margin-left: 10px;
      }
    }
  }

  .font-color {
    color: ${VARIABLES.COLORS.BLUE_4};
  }

  .item-list {
    margin-bottom: 10px;
    max-width: 300px;
    word-wrap: break-word;
    white-space: normal;
    display: block;
  }

  .item-list-icon {
    margin-bottom: 10px;
    max-width: 300px;
    word-wrap: break-word;
    white-space: normal;
  }

  .calculate {
    flex-wrap: wrap;

    .supplier-name {
      flex: 0 0 33.3%;
      padding: 0;
    }
  }

  .arrow {
    background-color: white;
    width: 24px !important;
    height: 21px;
    padding: 2px;
    border-radius: 4px;
  }

  .market-price {
    color: ${VARIABLES.COLORS.GREEN_1};
  }

  .note {
    flex-wrap: wrap;
    text-align: left;
    margin-top: 15px;
    margin-bottom: 15px;
    white-space: normal;
    /* max-width: 300px; */
    max-width: unset;
    word-wrap: break-word;
    display: block;

    label {
      width: 100%;
      padding-right: 10px;
    }
  }

  .average-price {
    color: ${VARIABLES.COLORS.RED_3};
    justify-content: end;
  }

  .bold {
    font-weight: 600;
  }

  .content-calculate {
    transition-timing-function: ease-out;
    transition: 0.2s;
  }

  .page-button {
    justify-content: flex-end;
  }

  .details-note {
    width: 130px;
    margin: 0 auto;
  }

  .supplier-item-save {
    margin-top: -130px;
  }

  .save-row {
    min-height: 230px;
    display: flex;
    flex-direction: column;
  }

  .header-calculate {
    background-color: ${VARIABLES.COLORS.GREEN_1};
    color: white;
    align-items: center;
    padding: 5px 15px;
    cursor: pointer;
    height: 36px;

    &.button-save {
      .arrow {
        margin-left: 10px;
        margin-bottom: 0;
      }
    }
  }

  .add-height {
    padding-top: 130px;
  }

  .rfq_status {
    position: relative;

    .image-control {
      position: absolute;
      right: 20px;
      cursor: pointer;
    }
  }

  /* Tooltip
  ------------------------------- */
  .__react_component_tooltip {
    padding: 5px 10px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.show {
      opacity: 1;
    }

    &.background-white {
      background-color: white;
      box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
      border: 0 !important;
      color: ${VARIABLES.COLORS.GRAY_3};
      white-space: pre-line;

      &.place-bottom {
        border-bottom-color: white;

        &:after,
        &before {
          display: none;
        }
      }

      &.place-top {
        border-top-color: white;

        &:after,
        &before {
          display: none;
        }
      }
    }
  }
  /* Truncate String
  ------------------------------- */
  .truncate_string_span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    display: inline-block;
    cursor: pointer;
  }

  .exchange-rate {
    width: 100%;

    .row {
      align-items: flex-start;
      justify-content: end;
    }

    .label {
      justify-content: end;
      flex-basis: auto;
      margin-left: auto;
    }

    .form-group-control {
      max-width: 100%;
    }

    input {
      text-align: right;
    }
  }

  /* modified input  */
  .group-input-custom {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .input-custom {
      flex: 1;
    }
    .input-custom:first-child {
      margin-right: 14px;
    }
  }

  .table-saving {
    margin-top: unset !important;
    .saving-type {
      flex: 0 0 19%;
      border-right: 2px solid #cccccc;
    }
    .reserve-price {
      flex: 0 0 27%;
      justify-content: center;
      border-right: 2px solid #cccccc;
    }
    .extended-price {
      flex: 0 0 27%;
      justify-content: center;
      border-right: 2px solid #cccccc;
    }
    .total-saving {
      flex: 0 0 27%;
      justify-content: center;
    }
  }

  .is-bottom {
    margin: auto auto 0 auto;
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .__react_component_tooltip {
      padding: 5px 9px;
      font-size: 16px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .__react_component_tooltip {
      padding: 4px 8px;
      font-size: 15px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 450px;
          min-width: 230px;
        }
      }

      &.status {
        .status-icon-help {
          width: 17px;
          left: 115px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 4px 7px;
      font-size: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .compare-list .item .button[class*='theme-'] {
      min-width: 100%;
      max-width: 170px;
      width: 100%;
    }

    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 400px;
          min-width: 210px;
        }
      }

      &.status {
        .status-icon-help {
          left: 105px;
          width: 16px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 3px 6px;
      font-size: 13px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .compare-list .item .button[class*='theme-'] {
      min-width: 100%;
      max-width: 170px;
      width: 100%;
      font-size: 0.65rem !important;
    }

    .form-group {
      &.date-period {
        .date-picker-wrapper {
          max-width: 350px;
          min-width: 180px;
        }
      }

      &.status {
        .status-icon-help {
          left: 95px;
          width: 15px;
        }
      }
    }

    .__react_component_tooltip {
      padding: 3px 5px;
      font-size: 12px;
    }
  }
`

// Supplier //
export const CompanyProfileSupplierFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
